import { useStaticQuery, graphql } from "gatsby"
import React from "react"
import Link from "components/Link"
import MarkdownContent from "components/MarkdownContent"
import presetBackground from "./background.svg"
import linkedinIcon from "./linkedin.svg"
import logoIcon from "./logo.svg"
import twitterIcon from "./twitter.svg"
import youtubeIcon from "./youtube.svg"

function Footer() {
  const { contentfulGlobalSettings } = useStaticQuery(graphql`
    query FooterQuery {
      contentfulGlobalSettings {
        menus {
          footerPrimaryMenu {
            items {
              label
              path
            }
            label
            path
          }
          footerSecondaryMenu {
            label
            path
          }
        }
        socialInformation {
          github {
            url
          }
          linkedin {
            url
          }
          youtube {
            url
          }
          twitter {
            url
          }
        }
        footerText {
          childrenMarkdownRemark {
            rawMarkdownBody
          }
        }
        companyAddressLine1
        companyAddressLine2
      }
    }
  `)

  return (
    <footer className="relative mt-16">
      <div className="px-5 lg:container">
        <img
          className="absolute left-0 top-0"
          src={presetBackground}
          alt="Preset"
        />
        <div className="relative z-10 py-10">
          <div className="grid grid-cols-2 gap-x-10 gap-y-12 md:grid-cols-3 md:gap-x-5 lg:grid-cols-6 lg:gap-x-10 lg:gap-y-10">
            <div className="col-span-2 md:col-span-3 lg:col-span-1">
              <Link href="/" title="Home">
                <img src={logoIcon} alt="Logo" width={40} />
              </Link>
              <div className="mt-7 text-sm">
                {contentfulGlobalSettings?.companyAddressLine1}
                <br />
                {contentfulGlobalSettings?.companyAddressLine2}
              </div>
              {contentfulGlobalSettings?.socialInformation && (
                <ul className="mt-7 flex items-center gap-x-5 lg:gap-x-8">
                  <li>
                    <Link
                      href={
                        contentfulGlobalSettings.socialInformation.twitter?.url
                      }
                      openNewTab
                    >
                      <img src={twitterIcon} alt="Twitter" />
                    </Link>
                  </li>
                  <li>
                    <Link
                      href={
                        contentfulGlobalSettings.socialInformation.linkedin?.url
                      }
                      openNewTab
                    >
                      <img src={linkedinIcon} alt="LinkedIn" />
                    </Link>
                  </li>
                  <li>
                    <Link
                      href={
                        contentfulGlobalSettings.socialInformation.youtube?.url
                      }
                      openNewTab
                    >
                      <img src={youtubeIcon} alt="YouTube" />
                    </Link>
                  </li>
                </ul>
              )}
            </div>
            {contentfulGlobalSettings?.menus?.footerPrimaryMenu?.map(
              (menuItem) => (
                <div key={menuItem.label}>
                  <h4 className="text-xl font-bold">
                    {menuItem.path ? (
                      <Link href={menuItem.path}>{menuItem.label}</Link>
                    ) : (
                      menuItem.label
                    )}
                  </h4>
                  {menuItem.items?.length > 0 && (
                    <ul className="mt-4 space-y-2 text-sm">
                      {menuItem.items.map((item) => (
                        <li key={item.label}>
                          <Link href={item.path}>{item.label}</Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )
            )}
          </div>
          <div className="mt-20 md:text-center">
            <ul className="divide-x text-xs text-neutral-500">
              {contentfulGlobalSettings?.menus?.footerSecondaryMenu?.map(
                (menuItem) => (
                  <Link
                    className="px-2 first:pl-0 last:pr-0"
                    href={menuItem.path}
                    key={menuItem.label}
                  >
                    {menuItem.label}
                  </Link>
                )
              )}
            </ul>
            <MarkdownContent
              className="mt-2 max-w-[300px] text-xs text-neutral-500 md:mx-auto"
              rawMarkdownBody={
                contentfulGlobalSettings?.footerText?.childrenMarkdownRemark[0]
                  ?.rawMarkdownBody
              }
            />
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
